import { Skeleton, Table } from 'antd';
import React from 'react';

const AttributeTable = ({ loading, columns, dataSource, onRowClick }) => {
  return loading ? (
    <Table
      columns={columns.map((column) => ({
        ...column,
        render: () => (
          <Skeleton.Input
            active
            style={{ width: column.width || 120 }}
            size="small"
          />
        ),
      }))}
      dataSource={Array(10)
        .fill(null)
        .map((_, index) => ({ key: index }))}
      pagination={false}
    />
  ) : (
    <Table
      loading={loading}
      columns={columns}
      dataSource={dataSource}
      rowKey="key"
      pagination={{
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} sur ${total} attributs`,
        defaultPageSize: 20,
        showSizeChanger: true,
        size: 'small',
        pageSizeOptions: ['10', '20', '50', '100'],
      }}
      scroll={{ y: 'calc(100vh - 350px)' }}
      onRow={(record) => ({
        onClick: () => onRowClick(record),
      })}
      style={{ cursor: 'pointer' }}
    />
  );
};

export default AttributeTable;
